import { createImageUrlBuilder, type SanityImageSource } from '@sanity/image-url';
import { client } from './client';

const builder = createImageUrlBuilder(client);

export const urlFor = (source: SanityImageSource | undefined | null) => {
  if (!source) return null;
  return builder.image(source);
};
